import type { IdentityState } from '@workspace/gtm/core';
import { hashData } from '@workspace/lib/utils/analytics/hash-data';

type SetIdentityArgs = {
  isAuthenticated: boolean;
  email: string | null;
  phone: string | null;
  applicationType?: string;
};

export async function composeIdentity({
  isAuthenticated,
  email,
  phone,
  applicationType,
}: SetIdentityArgs): Promise<IdentityState> {
  const userStatus =
    applicationType === 'NEW' || !applicationType ? 'NC' : 'RS';
  const hashedEmail = email ? await hashData(email) : 'undefined';
  const hashedPhone = phone ? await hashData(phone) : 'undefined';

  return {
    isLoggedIn: isAuthenticated,
    loginMethod: 'email',
    userStatus,
    emailSha: hashedEmail,
    telSha: hashedPhone,
    entryLocation: 'other',
  };
}
